/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Period_TermInputs */

const tr_iade_iptal_s2_period_term = /** @type {(inputs: Iade_Iptal_S2_Period_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Dönemi:`)
};

const en_iade_iptal_s2_period_term = /** @type {(inputs: Iade_Iptal_S2_Period_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Period:`)
};

const de_iade_iptal_s2_period_term = /** @type {(inputs: Iade_Iptal_S2_Period_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementzeitraum:`)
};

const ru_iade_iptal_s2_period_term = /** @type {(inputs: Iade_Iptal_S2_Period_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Период подписки:`)
};

/**
* | output |
* | --- |
* | "Subscription Period:" |
*
* @param {Iade_Iptal_S2_Period_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_period_term = /** @type {((inputs?: Iade_Iptal_S2_Period_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Period_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_period_term(inputs)
	if (locale === "de") return de_iade_iptal_s2_period_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_period_term(inputs)
	return tr_iade_iptal_s2_period_term(inputs)
});